const CBSLogo = () => {
     return (
          <img width="24px"
               height="24px"
               src={process.env.PUBLIC_URL + '/assets/images/logo.svg'} alt="Logo" />
     )
}
export default CBSLogo;

